<template>
  <v-container>
    <v-slide-y-transition mode="out-in">
      <v-layout column>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="search"
            solo
            append-icon="search"
            label="Search ...">
          </v-text-field>
        </v-flex>
        <v-flex v-if="ideas.length === 0" xs6>
          <SharedContentLoader v-for="i in 5" :key="i"></SharedContentLoader>
        </v-flex>
        <v-flex v-else xs6 class="mt-2">
          <v-list two-line>
            <template v-for="(idea, index) in filteredIdeas">
              <v-list-tile avatar :href="idea.url" target="_blank">
                <v-list-tile-content>
                  <v-list-tile-title>{{ idea.author }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ idea.idea }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn @click="vote(index, idea, 'up')">
                    <div>{{ getVotes(idea, 'up') }} &nbsp;</div>
                    <v-icon color="green">fas fa-arrow-up</v-icon>
                  </v-btn>
                  <v-btn @click="vote(index, idea, 'down')">
                    <div>{{ getVotes(idea, 'down') }} &nbsp;</div>
                    <v-icon color="red">fas fa-arrow-down</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  import SharedContentLoader from './Shared/SharedContentLoader';

  export default {
    name: 'ideas',
    components: {
      SharedContentLoader,
    },
    data() {
      return {
        ideas: [],
        search: '',
      };
    },
    computed: {
      filteredIdeas() {
        if (this.search === '') {
          return this.ideas;
        }

        const arr = Object.keys(this.ideas)
                          .map(k => this.ideas[k]);

        return arr.filter(idea => idea.idea.toLowerCase()
                                      .includes(this.search.toLowerCase()));
      },
    },
    methods: {
      getVotes(idea, direction) {
        if (!idea.votes || idea.votes === 0) return 0;
        return Object.entries(idea.votes)
                     .filter(e => e[1] === direction).length;
      },
      vote(ideaID, idea, direction) {
        const uid = this.$auth().currentUser.uid;
        this.$database()
            .ref(`ideas/${ideaID}`)
            .child('votes')
            .update({
              [uid]: direction,
            });
      },
      async fetchIdeas() {
        await this.$database()
                  .ref('ideas')
                  .on('value', (ideas) => {
                    this.ideas = ideas.val();
                  });
      },
    },
    mounted() {
      this.$auth()
          .onAuthStateChanged((user) => {
            if (user) {
              this.fetchIdeas();
            } else {
              this.$router.push('Login');
            }
          });
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Ideas.vue